import React, { useEffect, useState } from 'react';
import { Spinner } from 'reactstrap';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, Input, InputLabel, MenuItem, Rating, Select, TextField, TextareaAutosize, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
//import OneDriveTeste from "../OneDriveTeste/OneDriveTeste";
import { Edit } from '@material-ui/icons';
import oikosApi from '../../../services/oikos';
import qs from 'qs';
import DatePicker from 'react-datepicker';
import SearchableSelect from 'react-select'
import MaskedInput from '../../../components/Template/Input/MaskedInput';
import { parseCurrencyToNumber } from '../../../utils/fc';

const DadosContaAPagar = ( props ) => {

  useEffect(() => {

    if (props.selectedOrcItem === undefined || Object.keys(props.selectedOrcItem).length === 0) {
      console.log(props.orcItems.find(orcItem => orcItem.value === props.data.orcItem_id))
      props.setSelectedOrcItem(props.orcItems.find(orcItem => orcItem.value === props.data.orcItem_id));
    }
    if (Object.keys(props.selectedConta).length === 0) {
      props.setSelectedConta(props.todasAsContas.find(conta => conta.value === props.data.conta_id));
    }
    if (Object.keys(props.selectedCategoria).length === 0) {
      const categSelected = props.todasAsCategorias.find(categ => categ.value === props.data.categ_id);
      props.setSelectedCategoria(props.todasAsCategorias.find(categ => categ.value === props.data.categ_id));
      getOrcItems(categSelected.value)
    }
  },[])

  const getOrcItems = async (categ_id) => {
    let dataOrcItems = {
      orcItem_ativo: 1,
      categ_id: categ_id,
    }

    if (props.proj_orcRubrId) {
      const in_txt = `!IN!(SELECT orcItem_id FROM orcItem WHERE orcRubr_id IN (SELECT id_oikos FROM viewOrcRubr_taxonomia2 WHERE nivel3_id = ${props.proj_orcRubrId}))`;
      dataOrcItems = {
        orcItem_ativo: 1,
        orcItem_id: in_txt,
        categ_id: categ_id,
      }
    }

    const queryString = `/?${qs.stringify({
      action: 'get',
      table: 'orcItem',
      fields: {
        orcItem_id: 'value',
        "(CONCAT((SELECT rubrica FROM viewOrcRubr_taxonomia2 WHERE viewOrcRubr_taxonomia2.id_oikos = orcItem.orcRubr_id),'::',orcItem_desc))": 'label'
      },
      data: dataOrcItems,
      order: 'label'
    })}`;

    const resp = await oikosApi.get(queryString);

    const parsedArray = resp.data.map((caminho) => {
      return { value: caminho.value, label: caminho.label}
    },[])

    props.setOrcItems(parsedArray);
  }

  const handleSelectChangeOrcItem = (e) => {
    const selected = props.orcItems.find((orcamentoItem) => {if (orcamentoItem && e) return orcamentoItem.value === e.value});
    if (selected) {
      props.setSelectedOrcItem(selected); // Update with the full pj object
    }
  };

  const handleSelectChangeConta = (e) => {
    const selected = props.todasAsContas.find((conta) => {if (conta && e) return conta.value === e.value});
    if (selected) {
      props.setSelectedConta(selected); // Update with the full pj object
    }
  };

  const handleSelectChangeCategorias = (e) => {
    const selected = props.todasAsCategorias.find((categoria) => {if (categoria && e) return categoria.value === e.value});
    if (selected) {
      props.setSelectedCategoria(selected); // Update with the full pj object
    }
    props.setSelectedOrcItem({});
    getOrcItems(selected.value);
  };

  return (
    <>
      <DialogTitle>Dados da conta a pagar</DialogTitle>
      <DialogContent sx={{overflow: "visible"}}>
        <div className="d-flex">
          <div className='d-flex flex-column flex-fill'>
            <div className='mt-3'>
              <TextField
                fullWidth
                InputLabelProps={{shrink: true}}
                label='Descrição'
                size='small'
                style={{minWidth: "100px", padding: "8px !important"}}
                value={props.desc}
                onChange={e => props.setDesc(e.target.value)}
              />
            </div>
            {props.selectedCategoria &&
              <div className='mt-3 d-flex flex-row justify-content-between'>
                <div className='mr-5'>
                  <FormControl fullWidth>
                    <InputLabel sx={{backgroundColor: "white", width: "60px", paddingLeft: "5px"}} shrink={true} htmlFor="orcItem">Valor</InputLabel>
                    <MaskedInput
                      mask="R$ num"
                      unmask
                      inputRef={el => { const inputVlrGlobal = el }}
                      blocks={{
                        num: {
                          mask: Number,
                          scale: 2, // digits after point 0 for integers
                          signed: false, // disallow negative
                          thousandsSeparator: '.', // any single char
                          padFractionalZeros: false, // if true then pads zeros at end to the length of scale
                          normalizeZeros: false, // appends or removes zeros at ends
                          radix: ',', // fractional delimiter
                          min: 0,
                          max: 1000000000,
                        },
                      }}
                      lazy={false}
                      value={props.valor}
                      onAccept={value => {
                        props.setValor(value);
                      }}
                    />
                  </FormControl>
                </div>
                <div className='mr-5'>
                  <FormControl  style={{width: "250px"}}>
                    <InputLabel sx={{backgroundColor: "white", width: "60px", paddingLeft: "5px"}} shrink={true} htmlFor="conta">Conta</InputLabel>
                    <SearchableSelect
                      classNamePrefix="select2-selection"
                      placeholder="Selecionar..."
                      defaultValue={props.todasAsContas.find(conta => conta.value === props.data.conta_id)}
                      isDisabled={false}
                      isLoading={false}
                      isClearable={true}
                      isSearchable={true}
                      options={props.todasAsContas}
                      onChange={handleSelectChangeConta}
                      value={props.selectedConta}
                    />
                  </FormControl>
                </div>
                <div className='mr-5'>
                  <FormControl  style={{width: "250px"}}>
                    <InputLabel sx={{backgroundColor: "white", width: "70px", paddingLeft: "5px"}} shrink={true} htmlFor="conta">Categoria</InputLabel>
                    <SearchableSelect
                      classNamePrefix="select2-selection"
                      placeholder="Selecionar..."
                      defaultValue={props.todasAsCategorias.find(categ => categ.value === props.orcItems.categ_id)}
                      isDisabled={false}
                      isLoading={false}
                      isClearable={true}
                      isSearchable={true}
                      options={props.todasAsCategorias}
                      onChange={handleSelectChangeCategorias}
                      value={props.selectedCategoria}
                    />
                  </FormControl>
                </div>
              </div>
              }
            {
              props.selectedCategoria &&
              <div className='mt-3'>
                <FormControl fullWidth>
                  <InputLabel sx={{backgroundColor: "white", width: "60px", paddingLeft: "5px"}} shrink={true} htmlFor="orcItem">orcItem</InputLabel>
                    <SearchableSelect
                      classNamePrefix="select2-selection"
                      placeholder="Selecionar..."
                      defaultValue={props.orcItems.filter(x => x.value === props.data.orcItem_id)}
                      isDisabled={false}
                      isLoading={false}
                      isClearable={true}
                      isSearchable={true}
                      options={props.orcItems}
                      onChange={handleSelectChangeOrcItem}
                      value={props.selectedOrcItem}
                    />
                </FormControl>
              </div>
            }
            <div className='d-flex flex-row mt-3'>
              <div className='mr-5'>
                <span>Data Vencimento</span><br/>
                <DatePicker
                  placeholderText="__/__/_____"
                  locale="pt-BR"
                  className="form-control"
                  dateFormat="dd/MM/yyyy"
                  peekNextMonth
                  showMonthDropdown
                  showYearDropdown
                  selected={props.dataVenc}
                  dropdownMode="select"
                  onChange={date => props.setDataVenc(date)}
                />
              </div>
              <div>
                <span>Data Quitação</span><br/>
                <DatePicker
                  placeholderText="__/__/_____"
                  locale="pt-BR"
                  className="form-control"
                  dateFormat="dd/MM/yyyy"
                  peekNextMonth
                  showMonthDropdown
                  showYearDropdown
                  selected={props.dataQuit}
                  dropdownMode="select"
                  onChange={date => props.setDataQuit(date)}
                />
              </div>
            </div>
          </div>
        </div>
      </DialogContent>
    </>
  )
}

export default DadosContaAPagar;
